import type { BubbleProps } from '@/features/Bubble/types'
import {
  close,
  hidePreviewMessage,
  open,
  setInputValue,
  setPrefilledVariables,
  showPreviewMessage,
  toggle,
  unmount,
} from '@/features/Commands'

export function initBubble(props: BubbleProps) {
  const bubbleElement = document.createElement('netwatch-bubble')
  Object.assign(bubbleElement, props)
  document.body.prepend(bubbleElement)
}

interface NetwatchBot {
  initBubble: typeof initBubble
  close: typeof close
  hidePreviewMessage: typeof hidePreviewMessage
  open: typeof open
  setPrefilledVariables: typeof setPrefilledVariables
  showPreviewMessage: typeof showPreviewMessage
  toggle: typeof toggle
  setInputValue: typeof setInputValue
  unmount: typeof unmount
}

declare const window:
  | {
    NetwatchBot: NetwatchBot | undefined
  }
  | undefined

export function parseNetwatchBot() {
  return {
    initBubble,
    close,
    hidePreviewMessage,
    open,
    setPrefilledVariables,
    showPreviewMessage,
    toggle,
    setInputValue,
    unmount,
  }
}

export function injectNetwatchBotInWindow(netwatchBot: NetwatchBot) {
  if (typeof window === 'undefined')
    return
  window.NetwatchBot = { ...netwatchBot }
}
